export function needsNombreOcr(nombre) {
  if (!nombre) return true;
  if (/^Producto\s+/i.test(nombre)) return true;
  if (nombre.length < 5) return true;
  if (/^[IOH'\"!¡.\s]+$/i.test(nombre)) return true;
  return false;
}

export function displayNombre(product) {
  const n = product?.nombre?.trim();
  if (n && !needsNombreOcr(n)) return n;
  return null;
}
